export const padding = {
  padding06: '0.6rem',
  padding10: '1rem',
  padding12: '1.2rem',
  padding24: '2.4rem'
};



// WEBPACK FOOTER //
// ./styles/core/padding.style.js